module.exports = __webpack_public_path__ + "img/stage-5-animated.0f7b8790.png";